(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ln-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ln-footer-panels')) {
    customElements.define('ln-footer-panels', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const mobile = matchMedia('(max-width: 768px)');
        const applyLayout = () => this.querySelectorAll('details').forEach(panel => { panel.open = !mobile.matches; });
        applyLayout();
        mobile.addEventListener('change', applyLayout, options);
        this.addEventListener('click', event => {
          if (!mobile.matches && event.target.closest('summary')) event.preventDefault();
        }, options);
      }
      disconnectedCallback() { this.events?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-search-page"] && !Shopify.designMode) return;
  try {
    
  const initLnSearchSuggestions = () => {
    document.querySelectorAll('.ln-search-page__query').forEach((form) => {
      if (form.dataset.lnSearchReady === 'true') return;
      form.dataset.lnSearchReady = 'true';

      const input = form.querySelector('input[name="q"]');
      const submitButton = form.querySelector('.ln-search-page__submit');
      const panel = form.querySelector('[data-ln-search-suggestions]');
      const backdrop = form.closest('.ln-search-page')?.querySelector('[data-ln-search-backdrop]');
      const closeButton = form.querySelector('[data-ln-search-close]');
      const headerGroup = document.querySelector('#header-group');
      const pageWrapper = document.querySelector('.page-wrapper');
      if (!input || !panel || !backdrop || !closeButton) return;

      let debounceTimer;
      let controller;
      let requestNumber = 0;
      let activeIndex = -1;
      let renderedQuery = '';
      let allowOpen = false;

      const updateBackdropTop = () => {
        if (backdrop.hidden || !headerGroup) return;
        let bottom = 0;
        Array.from(headerGroup.children).forEach((section) => {
          const bounds = section.getBoundingClientRect();
          if (bounds.height > 0 && bounds.top < window.innerHeight && bounds.bottom > 0) {
            bottom = Math.max(bottom, Math.min(bounds.bottom, window.innerHeight));
          }
        });
        backdrop.style.top = `${Math.ceil(bottom)}px`;
        [input, submitButton, closeButton, panel].forEach((element) => {
          if (!element) return;
          const hiddenHeight = Math.max(0, Math.ceil(bottom - element.getBoundingClientRect().top));
          element.style.clipPath = hiddenHeight ? `inset(${hiddenHeight}px 0 0 0)` : '';
        });
      };

      const options = () => Array.from(panel.querySelectorAll('[role="option"]'));

      const open = () => {
        if (!allowOpen || !input.value.trim()) return;
        panel.hidden = false;
        backdrop.hidden = false;
        closeButton.hidden = false;
        form.classList.add('is-open');
        document.body.classList.add('ln-search-page--open');
        updateBackdropTop();
        input.setAttribute('aria-expanded', 'true');
      };

      const close = () => {
        allowOpen = false;
        activeIndex = -1;
        panel.hidden = true;
        backdrop.hidden = true;
        closeButton.hidden = true;
        form.classList.remove('is-open');
        document.body.classList.remove('ln-search-page--open');
        [input, submitButton, closeButton, panel].forEach((element) => {
          if (element) element.style.clipPath = '';
        });
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
      };

      const setActive = (index) => {
        const links = options();
        links.forEach((link) => {
          link.classList.remove('is-active');
          link.setAttribute('aria-selected', 'false');
        });
        activeIndex = index;

        if (index < 0 || !links[index]) {
          input.removeAttribute('aria-activedescendant');
          return;
        }

        const link = links[index];
        link.classList.add('is-active');
        link.setAttribute('aria-selected', 'true');
        input.setAttribute('aria-activedescendant', link.id);
        link.scrollIntoView({ block: 'nearest' });
      };

      const showMessage = (message) => {
        const text = document.createElement('p');
        text.className = 'ln-search-page__suggestion-message';
        text.textContent = message;
        panel.replaceChildren(text);
        setActive(-1);
        open();
      };

      const createViewAll = (query, index) => {
        const link = document.createElement('a');
        const destination = new URL(form.action, window.location.origin);
        destination.searchParams.set('q', query);
        destination.searchParams.set('options[prefix]', 'last');
        link.className = 'ln-search-page__view-all';
        link.href = destination.toString();
        link.id = `${panel.id}-option-${index}`;
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        link.tabIndex = -1;
        link.textContent = panel.dataset.viewAllLabel.replaceAll('&quot;', '"').replace('{query}', query);
        return link;
      };

      const render = (results, query) => {
        const collections = results.collections || [];
        const products = results.products || [];
        const columns = document.createElement('div');
        columns.className = 'ln-search-page__suggestion-columns';
        let optionIndex = 0;

        const addGroup = (items, label, includeImages) => {
          if (!items.length) return;
          const group = document.createElement('div');
          const heading = document.createElement('h3');
          group.className = 'ln-search-page__suggestion-group';
          group.setAttribute('role', 'group');
          group.setAttribute('aria-label', label);
          heading.textContent = label;
          group.append(heading);

          items.forEach((item) => {
            const link = document.createElement('a');
            link.className = 'ln-search-page__suggestion-option';
            link.href = item.url;
            link.id = `${panel.id}-option-${optionIndex}`;
            link.setAttribute('role', 'option');
            link.setAttribute('aria-selected', 'false');
            link.tabIndex = -1;
            optionIndex += 1;

            if (includeImages) {
              const imageData = item.featured_image;
              const imageUrl = imageData?.url || item.image;
              if (imageUrl) {
                const image = document.createElement('img');
                const source = new URL(imageUrl, window.location.origin);
                source.searchParams.set('width', '160');
                image.className = 'ln-search-page__suggestion-image';
                image.src = source.toString();
                image.alt = imageData?.alt || item.title;
                image.width = 80;
                image.height = 80;
                image.loading = 'lazy';
                link.append(image);
              }
            }

            const title = document.createElement('span');
            title.textContent = item.title;
            link.append(title);
            group.append(link);
          });

          columns.append(group);
        };

        addGroup(collections, panel.dataset.collectionsLabel, false);
        addGroup(products, panel.dataset.productsLabel, true);

        const viewAll = createViewAll(query, optionIndex);
        if (collections.length || products.length) {
          panel.replaceChildren(columns, viewAll);
        } else {
          const message = document.createElement('p');
          message.className = 'ln-search-page__suggestion-message';
          message.textContent = panel.dataset.noSuggestionsLabel;
          panel.replaceChildren(message, viewAll);
        }

        renderedQuery = query;
        setActive(-1);
        open();
      };

      const requestSuggestions = async (query, number) => {
        controller = new AbortController();
        const root = window.Shopify?.routes?.root || '/';
        const endpoint = new URL(`${root}search/suggest.json`, window.location.origin);
        endpoint.searchParams.set('q', query);
        endpoint.searchParams.set('resources[type]', 'collection,product');
        endpoint.searchParams.set('resources[limit]', '3');
        endpoint.searchParams.set('resources[limit_scope]', 'each');

        try {
          const response = await fetch(endpoint, {
            signal: controller.signal,
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) throw new Error(`Predictive search: ${response.status}`);
          const data = await response.json();
          if (number !== requestNumber || input.value.trim() !== query) return;
          render(data.resources?.results || {}, query);
        } catch (error) {
          if (error.name === 'AbortError' || number !== requestNumber) return;
          showMessage(panel.dataset.errorLabel);
        }
      };

      input.addEventListener('input', () => {
        const query = input.value.trim();
        window.clearTimeout(debounceTimer);
        controller?.abort();
        requestNumber += 1;

        if (!query) {
          panel.replaceChildren();
          renderedQuery = '';
          close();
          return;
        }

        allowOpen = true;
        showMessage(panel.dataset.loadingLabel);
        const number = requestNumber;
        debounceTimer = window.setTimeout(() => requestSuggestions(query, number), 180);
      });

      input.addEventListener('focus', () => {
        if (input.value.trim() && renderedQuery === input.value.trim()) {
          allowOpen = true;
          open();
        }
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          close();
          return;
        }

        if (panel.hidden) return;
        const links = options();

        if (event.key === 'ArrowDown' && links.length) {
          event.preventDefault();
          setActive((activeIndex + 1) % links.length);
        } else if (event.key === 'ArrowUp' && links.length) {
          event.preventDefault();
          setActive((activeIndex - 1 + links.length) % links.length);
        } else if (event.key === 'Enter' && activeIndex >= 0) {
          event.preventDefault();
          links[activeIndex].click();
        }
      });

      document.addEventListener('click', (event) => {
        if (panel.hidden || form.contains(event.target)) return;
        if (!document.querySelector('#header-group')?.contains(event.target)) {
          event.preventDefault();
          event.stopPropagation();
        }
        close();
      }, true);

      pageWrapper?.addEventListener('scroll', updateBackdropTop, { passive: true });
      window.addEventListener('scroll', updateBackdropTop, { passive: true });
      window.addEventListener('resize', updateBackdropTop, { passive: true });

      closeButton.addEventListener('click', close);
      form.addEventListener('submit', close);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLnSearchSuggestions, { once: true });
  } else {
    initLnSearchSuggestions();
  }

  document.addEventListener('shopify:section:load', initLnSearchSuggestions);

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-ln-search-sort]')) {
      event.target.form.requestSubmit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    const storageKey = 'ln_cart_reservation_end';
    const duration = 10 * 60 * 1000;
    let fallbackEnd = 0;

    const updateTimer = () => {
      const timer = document.querySelector('[data-ln-cart-page-timer]');
      if (!timer) return;

      let end = fallbackEnd;
      try { end = Number(sessionStorage.getItem(storageKey)) || fallbackEnd; }
      catch { end = fallbackEnd; }

      if (!end) {
        end = Date.now() + duration;
        fallbackEnd = end;
        try { sessionStorage.setItem(storageKey, String(end)); }
        catch { fallbackEnd = end; }
      }

      const secondsLeft = Math.max(0, Math.ceil((end - Date.now()) / 1000));
      timer.textContent = `${String(Math.floor(secondsLeft / 60)).padStart(2, '0')}:${String(secondsLeft % 60).padStart(2, '0')}`;
    };

    updateTimer();
    window.setInterval(updateTimer, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main-louise"]) return;
  try {
    
  if (!customElements.get('louise-product-main')) {
    customElements.define('louise-product-main', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          if (!matchMedia('(max-width: 749px)').matches) return;
          const button = event.target.closest('[data-lp-option-value]');
          if (!button) return;
          const input = [...this.querySelectorAll('variant-picker input[data-option-value-id]')].find(radio => radio.dataset.optionValueId === button.dataset.lpOptionValue);
          if (input && !input.checked && !input.disabled) input.click();
        }, { signal: this.controller.signal });
        this.addEventListener('scroll', event => {
          if (!matchMedia('(min-width: 750px)').matches) return;
          if (!(event.target instanceof Element) || !event.target.matches('.dialog-zoomed-gallery')) return;
          const dialog = event.target.closest('dialog');
          if (dialog?.open) dialog.dispatchEvent(new Event('scroll'));
        }, { capture: true, signal: this.controller.signal });
        this.observer = new MutationObserver(() => this.syncColors());
        this.observer.observe(this, { childList: true, subtree: true });
        this.syncColors();
        const gallery = this.querySelector('.lp-main__gallery');
        if (gallery && typeof ResizeObserver !== 'undefined') {
          const measureGallery = () => {
            const height = `${gallery.getBoundingClientRect().height}px`;
            if (gallery.style.getPropertyValue('--lp-gallery-height') !== height) {
              gallery.style.setProperty('--lp-gallery-height', height);
            }
          };
          this.galleryResizeObserver = new ResizeObserver(measureGallery);
          this.galleryResizeObserver.observe(gallery);
          measureGallery();
        }
        this.updateDate();
        this.timer = setInterval(() => this.updateDate(), 60000);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.galleryResizeObserver?.disconnect();
        clearInterval(this.timer);
      }
      syncColors() {
        const values = new Set([...this.querySelectorAll('.lp-main__gallery [data-lp-option-value]')].map(button => button.dataset.lpOptionValue));
        for (const fieldset of this.querySelectorAll('[data-lp-color-option]')) {
          const radios = [...fieldset.querySelectorAll('input[data-option-value-id]')];
          fieldset.classList.toggle('lp-main__color-in-gallery', radios.length > 1 && radios.every(radio => values.has(radio.dataset.optionValueId)));
        }
      }
      updateDate() {
        const date = new Date();
        date.setDate(date.getDate() + 1);
        const target = this.querySelector('[data-lp-dispatch]');
        if (target) target.textContent = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: '2-digit' }).format(date);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
